import { IndustryType } from "../hooks/useFile";
import { Sample } from "../types/sample";

export const INDUSTRY_TYPE_ORDER = [
  "business",
  "commerce",
  "finance",
  "general",
  "government",
  "foreign languages",
  "custom",
] as const;

export const INDUSTRY_TYPE_LABELS: Record<IndustryType, string> = {
  commerce: "Commerce",
  business: "Business",
  finance: "Finance",
  government: "Government",
  general: "General",
  "foreign languages": "Foreign languages",
  custom: "Custom",
};

export const EXTRACTOR_SAMPLES: Sample[] = [
  {
    id: "e1b2c3d4-e5f6-47g8-h9i0-j1k2l3m4n5o6",
    title: "Receipt",
    thumbnailPath: "/samples/extractor/KIE01.jpeg",
    filePath: "/samples/extractor/KIE01.json",
    documentInfo: {
      source: "Upstage",
      industryType: "commerce",
      docType: "receipt",
      modelName: "receipt-extraction-3.2.0",
    },
  },
  {
    id: "a1b2c3d4-e5f6-47g8-h9i0-j1k2l3m4n5o7",
    title: "Bill of lading",
    thumbnailPath: "/samples/extractor/KIE11.jpeg",
    filePath: "/samples/extractor/KIE11.json",
    documentInfo: {
      source: "Upstage",
      industryType: "commerce",
      docType: "bill",
      modelName: "bill-of-lading-and-shipping-request-extraction-4.1.6",
    },
  },
  {
    id: "b2c3d4e5-f6g7-48h9-i0j1-k2l3m4n5o6p7",
    title: "Shipping request",
    thumbnailPath: "/samples/extractor/KIE12.jpeg",
    filePath: "/samples/extractor/KIE12.json",
    documentInfo: {
      source: "Upstage",
      industryType: "commerce",
      docType: "bill",
      modelName: "bill-of-lading-and-shipping-request-extraction-4.1.6",
    },
  },
  {
    id: "c3d4e5f6-g7h8-49i0-j1k2-l3m4n5o6p7q8",
    title: "Commerial invoice",
    thumbnailPath: "/samples/extractor/KIE21.jpeg",
    filePath: "/samples/extractor/KIE21.json",
    documentInfo: {
      source: "Upstage",
      industryType: "commerce",
      docType: "invoice",
      modelName: "commercial-invoice-and-packing-list-extraction-4.1.6",
    },
  },
  {
    id: "d4e5f6g7-h8i9-50j1-k2l3-m4n5o6p7q8r9",
    title: "Packing list",
    thumbnailPath: "/samples/extractor/KIE22.jpeg",
    filePath: "/samples/extractor/KIE22.json",
    documentInfo: {
      source: "Upstage",
      industryType: "commerce",
      docType: "invoice",
      modelName: "commercial-invoice-and-packing-list-extraction-4.1.6",
    },
  },
  {
    id: "e5f6g7h8-i9j0-51k2-l3m4-n5o6p7q8r9s0",
    title: "Air waybill",
    thumbnailPath: "/samples/extractor/KIE31.jpeg",
    filePath: "/samples/extractor/KIE31.json",
    documentInfo: {
      source: "Upstage",
      industryType: "commerce",
      docType: "bill",
      modelName: "air-waybill-extraction-4.1.6",
    },
  },
  {
    id: "f6g7h8i9-j0k1-52l3-m4n5-o6p7q8r9s0t1",
    title: "Export declaration",
    thumbnailPath: "/samples/extractor/KIE41.jpeg",
    filePath: "/samples/extractor/KIE41.json",
    documentInfo: {
      source: "Upstage",
      industryType: "foreign languages",
      docType: "form",
      modelName: "kr-export-declaration-certificate-extraction-4.1.6",
    },
  },
];

export const OCR_SAMPLES: Sample[] = [
  {
    id: "g7h8i9j0-k1l2-53m4-n5o6-p7q8r9s0t1u2",
    title: "Bill of lading",
    thumbnailPath: "/samples/ocr/OCR01.jpeg",
    filePath: "/samples/ocr/OCR01.json",
    documentInfo: {
      industryType: "commerce",
      docType: "bill",
      modelName: "ocr-250904",
    },
  },
  {
    id: "h8i9j0k1-l2m3-54n5-o6p7-q8r9s0t1u2v3",
    title: "Business report",
    thumbnailPath: "/samples/ocr/OCR02.jpeg",
    filePath: "/samples/ocr/OCR02.json",
    documentInfo: {
      source: "AWS Cloud",
      industryType: "business",
      docType: "report",
      modelName: "ocr-250904",
    },
  },
  {
    id: "i9j0k1l2-m3n4-55o6-p7q8-r9s0t1u2v3w4",
    title: "Finance report",
    thumbnailPath: "/samples/ocr/OCR03.jpeg",
    filePath: "/samples/ocr/OCR03.json",
    documentInfo: {
      source: "Apple Inc.",
      industryType: "finance",
      docType: "report",
      modelName: "ocr-250904",
    },
  },
  {
    id: "j0k1l2m3-n4o5-56p7-q8r9-s0t1u2v3w4x5",
    title: "Business card",
    thumbnailPath: "/samples/ocr/OCR04.jpeg",
    filePath: "/samples/ocr/OCR04.json",
    documentInfo: {
      source: "Upstage",
      industryType: "business",
      docType: "card",
      modelName: "ocr-250904",
    },
  },
  {
    id: "k1l2m3n4-o5p6-57q8-r9s0-t1u2v3w4x5y6",
    title: "Technical article",
    thumbnailPath: "/samples/ocr/OCR05.jpeg",
    filePath: "/samples/ocr/OCR05.json",
    documentInfo: {
      source: "AWS",
      industryType: "foreign languages",
      docType: "article",
      modelName: "ocr-250904",
    },
  },
];

export const LAYOUT_ANALYSIS_SAMPLES: Sample[] = [
  {
    id: "l2m3n4o5-p6q7-58r9-s0t1-u2v3w4x5y6z7",
    title: "2023 Sustainability Report of SK networks",
    thumbnailPath: "/samples/layout-analysis/presentation_slide_thumbnail.jpeg",
    filePath: "/samples/layout-analysis/presentation_slide.json",
    documentInfo: {
      source: "SK networks",
      industryType: "business",
      docType: "report",
      modelName: "document-parse-250404",
    },
  },
  // {
  //   id: "m3n4o5p6-q7r8-59s0-t1u2-v3w4x5y6z7a8",
  //   title: "KLUE: Korean Language Understanding Evaluation",
  //   thumbnailPath:
  //     "/samples/layout-analysis/article_with_table_and_equation_thumbnail.jpeg",
  //   filePath: "/samples/layout-analysis/article_with_table_and_equation.json",
  //   documentInfo: {
  //     source: "https://arxiv.org/abs/2105.09680",
  //     industryType: "general",
  //     docType: "article",
  //     modelName: "LA",
  //   },
  // },
  {
    id: "n4o5p6q7-r8s9-60t1-u2v3-w4x5y6z7a8b9",
    title: "Administrative property use guide",
    thumbnailPath: "/samples/layout-analysis/japanese_guidebook_thumbnail.jpeg",
    filePath: "/samples/layout-analysis/japanese_guidebook.json",
    documentInfo: {
      industryType: "foreign languages",
      docType: "guide",
      modelName: "document-parse-250404",
    },
  },
  {
    id: "o5p6q7r8-s9t0-61u2-v3w4-x5y6z7a8b9c0",
    title: "Product long description",
    thumbnailPath:
      "/samples/layout-analysis/long_product_description_thumbnail.jpeg",
    filePath: "/samples/layout-analysis/long_product_description.json",
    documentInfo: {
      source: "Danawa",
      industryType: "general",
      docType: "guide",
      modelName: "document-parse-250404",
    },
  },
  {
    id: "p6q7r8s9-t0u1-62v3-w4x5-y6z7a8b9c0d1",
    title: "Stock market analysis",
    thumbnailPath:
      "/samples/layout-analysis/report_with_main_title_thumbnail.jpeg",
    filePath: "/samples/layout-analysis/report_with_main_title.json",
    documentInfo: {
      source: "Shinhan Securities",
      industryType: "foreign languages",
      docType: "report",
      modelName: "document-parse-250404",
    },
  },
  {
    id: "q7r8s9t0-u1v2-63w4-x5y6-z7a8b9c0d1e2",
    title: "Performance audit report",
    thumbnailPath: "/samples/layout-analysis/audit_report_thumbnail.jpeg",
    filePath: "/samples/layout-analysis/audit_report.json",
    documentInfo: {
      source: "Office of the Auditor General Republic of Botswana",
      industryType: "government",
      docType: "report",
      modelName: "document-parse-250404",
    },
  },
];
